import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useSuperAdminSingleSuborg } from "../../../context/SuperAdmin/SingleSuborgContext";

const HeadersSuborgTable = () => {
  const { toggleAddModal, toggleDeleteModal, searchQuery, setSearchQuery, selectedSuborgUsers } =
    useSuperAdminSingleSuborg();

  return (
    <Grid
      container
      sx={{ justifyContent: "space-between", alignContent: "center" }}
    >
      <Grid item>
        {/* Search bar */}
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: Colegio San José"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {/* Botones agrupados a la derecha */}
      <Grid item display="flex" gap={2}>
        <Button
          variant="outlined"
          onClick={() => toggleDeleteModal(true)}
          disabled={!selectedSuborgUsers.length}
          sx={{
            borderRadius: 14,
            border: "1px solid #336B87",
            color: "#336B87",
            "&:hover": {
              backgroundColor: "#336B87",
              color: "#EEF3F6",
            },
          }}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          onClick={() => toggleAddModal(true)}
          sx={{ background: "#336B87" }}
        >
          Agregar usuarios
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeadersSuborgTable;
